export default __webpack_public_path__ + "073f2ad22b07c054a3e132216724bd5f.png";